import { userType } from 'types';

export type RouteConfig = {
  name: string;
  description?: string;
  path: string;
  getPath: (params: any) => string;
  exact: boolean;
  isPrivate: boolean;
  isStatic?: boolean;
  allowedRoles?: userType[];
  allowedPermissions?: string[];
  topNavigation: boolean;
};

export type RouteKey =
  | 'report'
  | 'home'
  | 'login'
  | 'index'
  | 'addpart'
  | 'editpart'
  | 'brands'
  | 'users'
  | 'country_of_origin'
  | 'userDetail'
  | 'recycle'
  | 'languages'
  | 'staticAsset';

type RouteConfigsType =
  {
    [key in RouteKey]: RouteConfig;
  }

export const RouteConfigs: RouteConfigsType = {
  home: {
    name: 'Home',
    path: '/',
    getPath: () => {
      return `/`;
    },
    exact: true,
    isPrivate: true,
    topNavigation: true,
    allowedRoles: ['super admin'],
    allowedPermissions: ['access rap usage reports']
  },
  report: {
    name: 'Report',
    path: '/report',
    getPath: () => {
      return `/report`;
    },
    exact: true,
    isPrivate: true,
    topNavigation: true,
    allowedRoles: ['admin', 'super admin']
  },
  index: {
    name: 'Parts',
    description: 'Parts',
    path: '/parts',
    getPath: () => {
      return `/parts`;
    },
    exact: true,
    isPrivate: true,
    topNavigation: true,
    allowedRoles: ['admin', 'super admin']
  },
  addpart: {
    name: 'Add Part',
    path: '/parts/add',
    getPath: () => {
      return `/parts/add`;
    },
    exact: true,
    isPrivate: true,
    topNavigation: false,
    allowedRoles: ['admin', 'super admin']
  },
  editpart: {
    name: 'Edit Part',
    path: '/parts/edit',
    getPath: () => {
      return `/parts/edit`;
    },
    exact: true,
    isPrivate: true,
    topNavigation: false,
    allowedRoles: ['admin', 'super admin']
  },
  brands: {
    name: 'Brands',
    path: '/brands',
    getPath: () => {
      return `/brands`;
    },
    exact: true,
    isPrivate: true,
    topNavigation: true,
    allowedRoles: ['admin', 'super admin']
  },
  users: {
    name: 'Users',
    path: '/users',
    getPath: () => {
      return `/users`;
    },
    exact: true,
    isPrivate: true,
    topNavigation: true,
    allowedRoles: ['admin', 'super admin', 'distributor', 'employee']
  },
  country_of_origin: {
    name: 'Country Origin',
    path: '/country_of_origin',
    getPath: () => {
      return `/country_of_origin`;
    },
    exact: true,
    isPrivate: true,
    topNavigation: true,
    allowedRoles: ['admin', 'super admin']
  },
  userDetail: {
    name: 'User Info',
    path: '/user/:id',
    getPath: (id: string) => {
      return `/user/${id}`;
    },
    exact: false,
    isPrivate: true,
    isStatic: false,
    topNavigation: false,
    allowedRoles: ['admin', 'super admin', 'distributor', 'employee']
  },
  languages: {
    name: 'Language keys',
    path: '/language',
    getPath: (id: string) => {
      return `/language`;
    },
    exact: false,
    isPrivate: true,
    isStatic: false,
    topNavigation: true,
    allowedRoles: ['admin', 'super admin']
  },
  recycle: {
    name: 'Recycle Bin',
    path: '/recycle',
    getPath: (id: string) => {
      return `/recycle`;
    },
    exact: false,
    isPrivate: true,
    isStatic: false,
    topNavigation: true,
    allowedRoles: ['admin', 'super admin']
  },
  staticAsset: {
    name: 'Static Assets',
    path: '/static-assets',
    getPath: (id: string) => {
      return `/static-assets`;
    },
    exact: false,
    isPrivate: true,
    isStatic: false,
    topNavigation: true,
    allowedRoles: ['admin', 'super admin']
  },
  login: {
    name: 'Log In',
    path: '/login',
    getPath: () => {
      return `/login`;
    },
    exact: true,
    isPrivate: false,
    topNavigation: false
  }
};

export const RouteKeys = Object.keys(RouteConfigs) as RouteKey[];